export default __webpack_public_path__ + "static/media/Sunjad_Beta.f3c48495.svg";